module.exports = [{"id":1,"name":"1次"},{"id":2,"name":"2次"},{"id":3,"name":"3次"},{"id":-1,"name":"循环"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/god_sequence_time.json
// module id = 4vos
// module chunks = 1